import * as React from "react";
import { ZUid } from "src/types/zUid";
import { onError } from "src/common/onError";
import { observer } from "mobx-react-lite";
import { LoaderBox } from "src/components/LoaderBox";
import { Tabs } from "antd";
import { bom2aStore as store } from "./Bom2aStore";
import styles from "./Bom2aControl.module.less";
import { Bom2aSummary } from "./Bom2aSummary";
import { Bom2aPositions } from "./Bom2aPositions";

interface PropsBom2aControl {
  objectServiceId: ZUid;
  entityId: ZUid;
  modelObjectId: ZUid;
}

export const Bom2aControl: React.FC<PropsBom2aControl> = observer((props) => {
  const { objectServiceId, entityId, modelObjectId } = props;
  React.useEffect(() => {
    store.init(objectServiceId, entityId, modelObjectId).catch(onError);
  }, [objectServiceId, entityId]);

  return <LoaderBox remoteData={store.data} drawReady={() => <Inner />} />;
});

const closeBom = () => store.setCurBom(null);

const Inner: React.FC = observer(() => {
  const { curBom } = store;
  return (
    <div className={styles.frame}>
      {curBom ? (
        <Bom2aPositions
          bom={curBom}
          store={store.editorStore}
          onClose={closeBom}
          modelObjectId={store.modelObjectId}
          objectServiceId={store.objectServiceId}
        />
      ) : (
        <>
          <Tabs
            type="card"
            items={store.tabs}
            activeKey={store.curTabKey}
            onChange={(activeKey) => store.setCurTab(activeKey)}
          />
          <Bom2aSummary />
        </>
      )}
    </div>
  );
});
